export default __webpack_public_path__ + "static/media/report3.d1c73c0f.svg";